import React from 'react';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm, ILeaveToRemain } from '../../../../../types';
import { SummaryGroup } from '../../../../Summary/SummaryGroup';
import { Box } from '@chakra-ui/react';

function VisaPrepAdditionalHistoryStep5Info(props: IVisaPrepForm) {
  const renderLeaveToRemains = () => {
    const allLeaveToRemains: React.ReactNode[] = [];
    if (props.leaveToRemains && props.leaveToRemains.length) {
      props.leaveToRemains.forEach((leaveToRemain: ILeaveToRemain, i: number) => {
        allLeaveToRemains.push(
          <SummaryGroup title={`Leave application ${i + 1}`} key={i}>
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.LEAVE_TO_REMAIN_DATE}-${i}`}
              label="Date of Application"
              value={leaveToRemain.applicationDate}
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.LEAVE_TO_REMAIN_TYPE}-${i}`}
              value={leaveToRemain.applicationType}
              label="Type of application"
            />
            <SummaryRow
              className={'visa-summary'}
              key={`${VQ.LEAVE_TO_REMAIN_REFERENCE}-${i}`}
              value={leaveToRemain.reference}
              label="Home Office Reference Number"
            />
          </SummaryGroup>,
        );
      });
    }
    return allLeaveToRemains;
  };
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        label="How many times did you apply for Leave to Remain in the UK?"
        value={props.leaveToRemains?.length}
      />

      <Box as="ol" pl={8} key={'leave-to-remains'}>
        {renderLeaveToRemains()}
      </Box>
    </>
  );
}

export default VisaPrepAdditionalHistoryStep5Info;
